// extracted by mini-css-extract-plugin
export default {"layout":"AddComplianceItem_layout__cZLb6","border":"AddComplianceItem_border__KYkZG"};